import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Navbar";
import { CONTACT } from "@/lib/data";

export default function Footer() {
  return (
    <footer className="border-t border-line bg-panel" data-testid="footer">
      <div className="hazard-stripes h-2 w-full" />
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 md:grid-cols-3 lg:px-8">
        <div>
          <div className="flex items-center gap-3">
            <LogoMark size={40} />
            <span className="font-display text-2xl font-extrabold uppercase text-bright">
              ELT <span className="text-hazard">Freight</span> &amp; Logistics
            </span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#9CA3AF]">
            Independent freight brokerage &amp; logistics coordination. Connecting Freight. Coordinating Capacity. Delivering Solutions.
          </p>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-brass">Navigate</p>
          <div className="mt-4 flex flex-col gap-2">
            {[
              ["Services", "/services"],
              ["For Shippers", "/shippers"],
              ["For Carriers", "/carriers"],
              ["About ELT", "/about"],
              ["Contact", "/contact"],
            ].map(([label, to]) => (
              <Link key={to} to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm text-[#9CA3AF] transition-colors hover:text-hazard">
                {label}
              </Link>
            ))}
          </div>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-brass">Dispatch Desk</p>
          <div className="mt-4 flex flex-col gap-2 text-sm text-[#9CA3AF]">
            <span data-testid="footer-address">ELT Freight &amp; Logistics<br />4430 112 Ave SE<br />Calgary, Alberta T2C 2K2, Canada</span>
            <a data-testid="footer-phone" href={CONTACT.phoneHref} className="transition-colors hover:text-hazard">{CONTACT.phone}</a>
            <a data-testid="footer-email-dispatch" href={`mailto:${CONTACT.dispatch}`} className="transition-colors hover:text-hazard">{CONTACT.dispatch}</a>
          </div>
        </div>
      </div>
      <div className="border-t border-line">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-2 px-5 py-5 font-mono text-[11px] uppercase tracking-[0.2em] text-dim sm:flex-row sm:items-center lg:px-8">
          <span>© {new Date().getFullYear()} ELT Freight &amp; Logistics. All rights reserved.</span>
          <div className="flex items-center gap-5">
            <Link to="/privacy" data-testid="footer-link-privacy" className="transition-colors hover:text-hazard">Privacy</Link>
            <Link to="/terms" data-testid="footer-link-terms" className="transition-colors hover:text-hazard">Terms</Link>
            <span>Calgary, AB T2C 2K2 — Canada &amp; North America</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
